import React from "react";
import styles from "./index.module.scss";
const Sidebar = () => {
  return (
    <div className={styles.root}>
      <img src="" alt="" />
    </div>
  );
};

export default Sidebar;
